import React from "react";
import { Link } from "react-router-dom";
import facebookLogo from "../assets/Facebook_Logo_Primary.png"; // put your FB SVG/PNG here
import "../CSS_stuff/Footnote.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        All images and text copyrighted by Rising Dragon Books, Mangala McNamara,
        and Shamus McNamara.
        <br />
        Website and Rising Dragons Logo design by Priyadevi McNamara.
      </p>

      <div className="footer-links">
        {/* internal newsletter link */}
        <Link to="/newsletter" className="footer-link">
          Newsletter
        </Link>

        {/* external Facebook link with logo */}
        <a
          href="https://www.facebook.com/RisingDragonBooks"
          className="footer-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={facebookLogo}
            alt="Facebook"
            className="footer-icon"
          />
        </a>
        {/* internal newsletter link */}
        <Link to="https://unsubscribe.mailerlite.io/unsubscribe/1591921/158680832784991960?signature=f6d92642f5720af28ac30a25abfad7c16d13fb36355d76683b2b3e2b9c6556d4" className="footer-link">
          Unsubscribe from Newsletter
        </Link>
      </div>
    </footer>
  );
};

export default Footer;